module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', _vm._l((_vm.notification), function(notif) {
    return _c('div', {
      staticClass: "row columns bordered",
      on: {
        "click": function($event) {
          return _vm.notifClicked(notif)
        }
      }
    }, [_c('div', {
      staticClass: "small-3 columns user-icon",
      on: {
        "click": function($event) {
          return _vm.notifClicked(notif)
        }
      }
    }, [_c('img', {
      staticClass: "circular",
      attrs: {
        "src": _vm.getUserAvatar(notif.actor.id),
        "alt": "team"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "small-9 columns text-left",
      on: {
        "click": function($event) {
          return _vm.notifClicked(notif)
        }
      }
    }, [_c('div', {
      staticClass: "row columns"
    }, [_c('div', {
      staticClass: "small-12 description"
    }, [_vm._v("\n                    " + _vm._s(_vm.getDescription(notif)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "small-12 time"
    }, [_c('i', {
      class: _vm.getIcon(notif),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(_vm.getTime(notif)) + "\n                    ")])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-9 columns"
  }, [_vm._v("\n          Dernières activités\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330401bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/activity-panel.vue
// module id = 730
// module chunks = 0